// extracted by mini-css-extract-plugin
module.exports = {"toggle-button":"styles-module__toggle-button___2wzyv"};